import React from "react";
import Redrecord from "../../fastparity/record/Redrecord";
import "../../fastparity/record/Record.css";
import Redrecord1 from "../../fastparity/record/Redrecord1";
const Record1 = ({ biddataparity, period1 }) => {
  return (
    <>
      <div>
        <div className="center-record">
        <Redrecord1 bgcolor={"orange"} numresult={"?"} period={period1} />
          {biddataparity &&
            biddataparity
              .reverse()
              .slice(0, 30)
              .map((item) => {
                return (
                  <>
                    <div style={{ width: "3px" }}></div>

                    <Redrecord
                      bgcolor={item.result}
                      numresult={item.number}
                      period={item.period}
                    />
                  </>
                );
              })}
          <div style={{ width: "3px" }}></div>
       
        </div>
      </div>
    </>
  );
};

export default Record1;
